import _ from "lodash";

// converts old database values to current values
const backport = (element) => {
  let options = { ...element.options };

  let buttonBorderWidth = options["button-border-width"];
  if (buttonBorderWidth && buttonBorderWidth.indexOf("px") > -1) {
    options["button-border-width"] = buttonBorderWidth.replace("px", "");
  }

  return options;
};

export const buildButtonStylesheet = (builder, device, cta, element) => {
    let options = backport(element);

    let borderRadius = "";
    if (options["button-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["button-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["button-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["button-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["button-radius-" + side]) == false
              ? options["button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;
    let boxShadowHover;

    if (options["button-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["button-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["button-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    let buttonFont;
    if (options["button-font"] && options["button-font"] !== "theme") {
      buttonFont = options["button-font"];
    }

    let fontWeight;
    if (
      options["button-font-weight"] &&
      options["button-font-weight"] !== "theme"
    ) {
      fontWeight = options["button-font-weight"];
    }

    let fontSize;
    if (options["button-font-size"]) {
      fontSize = options["button-font-size"];
    }

    if (options["button-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["button-shadow-horizontal-distance"]
          ? `${element.options["button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-vertical-distance"]
          ? `${element.options["button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-blur-radius"]
          ? `${element.options["button-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["button-shadow-spread-radius"]
          ? `${element.options["button-shadow-spread-radius"]}px`
          : "0px") + " ";

      const shadowColor =
        element.options["button-shadow-color"] || "rgba(0,0,0, 0.35)";
      const hoverShadowColor =
        element.options["button-hover-shadow-color"] || shadowColor;

      boxShadowHover = `${boxShadow}${hoverShadowColor}`;
      boxShadow += shadowColor;

      if (element.options["button-shadow-inset"] == "true") {
        boxShadow += " inset";
        boxShadowHover += " inset";
      }
    }

    let maxWidth;
    if (options["max-width"]) {
      maxWidth = options["max-width"];
    }

    let buttonCustomWidth;
    if (options["button-width"] == 'custom' && options["button-width-value"]) {
      buttonCustomWidth = options["button-width-value"] + 'px';
    }

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-button[data-element-id="${element.id}"] {
  ${options["button-color"] ? 'background: ' + options["button-color"] + '!important;' : ''}
  ${options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
  ${buttonCustomWidth ? `width: ${buttonCustomWidth};` : ''}
  ${options["button-size"] == 'custom' && options["button-size-value"] ? 'padding: ' + options["button-size-value"] + 'px 20px !important;' : ''}
  ${options["button-border-style"] ? 'border-style: ' + options["button-border-style"] + ' !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width"]) == false ? 'border-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-left"]) == false ? 'border-left-width: ' + options["button-border-width-left"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-left-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-right"]) == false ? 'border-right-width: ' + options["button-border-width-right"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-right-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-top"]) == false ? 'border-top-width: ' + options["button-border-width-top"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-top-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && _.isNil(options["button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["button-border-width-bottom"] + 'px !important;' : _.isNil(options["button-border-width"]) == false ? 'border-bottom-width: ' + options["button-border-width"] + 'px !important;' : ''}
  ${options["button-border-style"] !== "" && options["button-border-color"] ? 'border-color: ' + options["button-border-color"] + ' !important;' : options["button-color"] ? 'border-color: ' + options["button-color"] + ' !important;' : ''}
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  max-width: 100%;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] {
  ${maxWidth ? `max-width: ${maxWidth}px;` : ''}
  margin-left: auto !important;
  margin-right: auto !important;
}

#cta_${cta.id} .cf-button[data-element-id="${element.id}"]:hover, #cta_${cta.id} .cf-button[data-element-id="${element.id}"]:active {
  ${options["button–hover-color"] ? 'background: ' + options["button–hover-color"] + ' !important;' : options["button-color"] ? 'background: ' + options["button-color"] + ' !important;' : ''}
  ${options["button–hover-text-color"] ? 'color: ' + options["button–hover-text-color"] + ' !important;' : options["button-text-color"] ? 'color: ' + options["button-text-color"] + ' !important;' : ''}
  ${options["button-hover-border-color"] ? 'border-color: ' + options["button-hover-border-color"] + ' !important;' : options["button-border-color"] ? 'border-color: ' +  options["button-border-color"] + ' !important;' : ''}
  ${boxShadowHover ? 'box-shadow: ' + boxShadowHover + ' !important;' : ''}
}

#cta_${cta.id} .cf-button[data-element-id="${element.id}"],
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] p,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] div,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h1,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h2,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h3,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h4 {
  ${buttonFont ? `font-family: ${buttonFont} !important;` : ''}
  ${fontWeight ? `font-weight: ${fontWeight} !important;` : ''}
  ${fontSize ? `font-size: ${fontSize}px !important;` : ''}
}
`;

    let fontSizeMobile;
    if (options["button-font-size-mobile"]) {
      fontSizeMobile = options["button-font-size-mobile"];
    }

    let maxWidthMobile;
    if (options["max-width-mobile"]) {
      maxWidthMobile = options["max-width-mobile"];
    }

    let buttonCustomWidthMobile = "";
    if (options["button-width-mobile"] && options["button-width-mobile"] !== "custom") {
      buttonCustomWidthMobile = "initial";
    } else if (options["button-width-mobile"] == "custom" && options["button-width-value-mobile"]) {
      buttonCustomWidthMobile = `${options["button-width-value-mobile"]}px`;
    }

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */

#cta_${cta.id} .cf-button[data-element-id="${element.id}"],
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] p,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] div,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h1,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h2,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h3,
#cta_${cta.id} .cf-button[data-element-id="${element.id}"] h4 {
  ${fontSizeMobile ? `font-size: ${fontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] {
  ${maxWidthMobile ? `max-width: ${maxWidthMobile}px;` : ''}
}

#cta_${cta.id} .cf-button[data-element-id="${element.id}"] {
  ${buttonCustomWidthMobile ? `width: ${buttonCustomWidthMobile} !important;` : ''}
}
`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
